import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import InfoPublication from "../publication/infoPublication";
import Infoproject from "../projet/infoProjet";
import { baseApiUrl } from "../../../services/api";

function Gauche() {
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [publications, setPublications] = useState([]);
  const [projects, setProjects] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  // Fonction pour récupérer les publications actives et récentes
  const fetchPublications = async () => {
    try {
      const response = await baseApiUrl.get("/publication/liste");

      // Vérifier que les données existent et sont un tableau
      if (response.data && Array.isArray(response.data)) {
        // Filtrer et transformer les publications
        const preparedPublications = response.data
          .filter(item => item && typeof item === 'object' && item.actif === true)
          .sort((a, b) => new Date(b.dateCreation || b.created || 0) - new Date(a.dateCreation || a.created || 0))
          .slice(0, 3);

        setPublications(preparedPublications);
        console.log("Publications récentes récupérées :", preparedPublications);
      } else {
        setPublications([]);
        console.error("Format de données invalide pour les publications");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des publications :", error);
      setPublications([]);
      setError("Erreur lors du chargement des publications");
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await baseApiUrl.get("/projet/liste");

      if (response.data && Array.isArray(response.data)) {
        const preparedProjects = response.data
          .filter(item => item && typeof item === 'object' && item.actif === true)
          .sort((a, b) => new Date(b.dateCreation || b.created || 0) - new Date(a.dateCreation || a.created || 0))
          .slice(0, 3);

        setProjects(preparedProjects);
        console.log("Projets récents récupérés :", preparedProjects);
      } else {
        setProjects([]);
        console.error("Format de données invalide pour les projets");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des projets :", error);
      setProjects([]);
      setError("Erreur lors du chargement des projets");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await baseApiUrl.get("/categorie/liste");
      if (response.data && Array.isArray(response.data)) {
        const options = response.data
          .filter(category => category && typeof category === 'object')
          .map(category => ({
            value: category.id || 0,
            label: category.nom || "Sans catégorie"
          }));
        setCategoriesOptions(options);
      } else {
        setCategoriesOptions([]);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des catégories:", error);
      setCategoriesOptions([]);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded);
      } catch (error) {
        console.error("Erreur lors du décodage du token :", error);
      }
    }

    fetchCategories();
    fetchPublications();
    fetchProjects();
  }, []);

  const handleVoirPlusPublications = () => navigate("/publications");
  const handleVoirPlusprojects = () => navigate("/projets");
  const handleContactezNous = () => navigate("/contact");

  if (isLoading) {
    return (
      <div className="container text-center my-5">
        <p>Chargement des données...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container text-center my-5">
        <p className="text-danger">{error}</p>
        <button
          className="btn"
          onClick={() => window.location.reload()}
          style={{ backgroundColor: '#FF8C00', color: 'white' }}
        >
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <div className="container">
      <section className="publications-section mb-5 pb-5">
        <div className="section-title text-center mb-5">
          <h2 className="title" style={{ color: '#FF8C00', marginBottom: '10px' }}>Publications Récentes</h2>
          <p style={{ color: '#555' }}>Découvrez nos dernières publications</p>
        </div>

        <div className="projects-area">
          <div className="row g-4">
            {publications.length > 0 ? (
              publications.map((publication, index) => {
                if (!publication) return null;

                return (
                  <InfoPublication
                    key={index}
                    publication={publication}
                    categoriesOptions={categoriesOptions}
                  />
                );
              })
            ) : (
              <div className="col-12 text-center">
                <p>Aucune publication disponible pour le moment.</p>
              </div>
            )}
          </div>
        </div>

        {publications.length > 0 && (
          <div className="text-center mt-4">
            <button
              className="btn"
              onClick={handleVoirPlusPublications}
              style={{ backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', borderRadius: '5px' }}
            >
              Voir plus de publications
            </button>
          </div>
        )}
      </section>

      <hr className="my-5" style={{ borderTop: '1px solid #eee' }} />

      <section className="projects-section mb-5 pb-5">
        <div className="section-title text-center mb-5">
          <h2 className="title" style={{ color: '#FF8C00', marginBottom: '10px' }}>Projets Récents</h2>
          <p style={{ color: '#555' }}>Explorez nos derniers projets</p>
        </div>

        <div className="projects-area">
          <div className="row g-4">
            {projects.length > 0 ? (
              projects.map((project, index) => {
                if (!project) return null;

                try {
                  return (
                    <Infoproject
                      key={index}
                      project={project}
                      categoriesOptions={categoriesOptions}
                    />
                  );
                } catch (error) {
                  console.error("Erreur lors du rendu d'Infoprojet:", error);
                  return (
                    <div className="col-md-4" key={index}>
                      <div className="card">
                        <div className="card-body">
                          <h5 className="card-title" style={{ color: '#FF8C00' }}>{project.titre || "Sans titre"}</h5>
                          <p className="card-text">Erreur lors du chargement de ce projet</p>
                        </div>
                      </div>
                    </div>
                  );
                }
              })
            ) : (
              <div className="col-12 text-center">
                <p>Aucun projet disponible pour le moment.</p>
              </div>
            )}
          </div>
        </div>

        {projects.length > 0 && (
          <div className="text-center mt-4">
            <button
              className="btn"
              onClick={handleVoirPlusprojects}
              style={{ backgroundColor: '#4CAF50', color: 'white', padding: '10px 20px', borderRadius: '5px' }}
            >
              Voir plus de projets
            </button>
          </div>
        )}
      </section>

      <hr className="my-5" style={{ borderTop: '1px solid #eee' }} />

      <section className="contact-section my-5">
        <div className="p-5 rounded text-center" style={{ borderLeft: '5px solid #FFD700', backgroundColor: '#FFFFFF' }}>
          <h3 style={{ color: '#FF8C00' }}>Vous avez un projet ou une publication à partager ?</h3>
          <p className="mb-4" style={{ color: '#555' }}>Nous vous invitons à partager votre travail avec notre communauté.</p>
          <button
            className="btn"
            onClick={handleContactezNous}
            style={{ backgroundColor: '#FF8C00', color: 'white', padding: '10px 20px', borderRadius: '5px' }}
          >
            Contactez-nous
          </button>
        </div>
      </section>
    </div>
  );
}

export default Gauche;
